/**
 * WordPress dependencies
 */
export * from '@wordpress/compose';
